import { render, staticRenderFns } from "./DashboardFtrInvest.vue?vue&type=template&id=59a7bcea"
import script from "./DashboardFtrInvest.vue?vue&type=script&lang=js"
export * from "./DashboardFtrInvest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports